import * as actionTypes from './actionTypes';
import { UserList } from '@app/src/views/Users/list/models/userList';

interface State {
  isFetching: boolean;
  errorMessage: string;
  data: UserList;
  idUser: number;
}

const initialState = {
  data: {
    code: null,
    data: [],
    message: '',
    page: {
      total: null,
      current: null,
      totalRow: null
    }
  },
  idUser: null,
  isFetching: false,
  errorMessage: ''
};

export const userList = (state: State = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_USER_LIST_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case actionTypes.FETCH_USER_LIST_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false
      };

    case actionTypes.FETCH_USER_LIST_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: ''
      };

    default:
      return state;
  }
};
